$(document).ready(function () {
	// Obtener el parámetro 'p' de la URL
	const urlParams = new URLSearchParams(window.location.search);
	const tab = urlParams.get('p');

	// Si hay un parámetro 'p', activar el tab correspondiente
	if (tab) {
		$('.nav-link').removeClass('active');
		$('.tab-pane').removeClass('show active');

		$(`#v-pills-${tab}-tab`).addClass('active');
		$(`#v-pills-${tab}`).addClass('show active');
	}
	$("#modal-register").on("hidden.bs.modal", function () {

		$("#formRegisterUser")[0].reset()
		$('#formRegisterUser .was-validated').removeClass('was-validated');

	})




	$("#formEditUser").submit(function (e) {
		e.preventDefault();

		var datos = new FormData(this);
		datos.append("editPerfil", "true");

		$.ajax({
			url: "/ajax/ajax.usuarios.php",
			method: "POST",
			data: datos,
			cache: false,
			contentType: false,
			processData: false,
			dataType: "json",
			success: function (respuesta) {

				
				$('#formEditUser .was-validated').removeClass('was-validated');

				if (respuesta.status == 200) {
					fncSweetAlertTimer("success", "Datos actualizador!", null, null);
					setTimeout(() => {
							// window.location.reload();

							const parametros = new URLSearchParams(window.location.search);
							parametros.set('p', 'perfil');  // Establece o actualiza el parámetro 'p'

							const nuevaUrl = window.location.pathname + '?' + parametros.toString();  // Obtiene la nueva URL con los parámetros actualizados
							window.location.href = nuevaUrl;  // Redirige a la nueva URL

					}, 2000);

				} else {
					fncSweetAlert("error", null, "¡Error al actualizar los datos, inténtelo nuevamente!", localStorage.getItem("rutaActual"));
				}



			}

		})

	})




	$("#confirmar_password_usuario").change(function () {
		var password = $("input[name=password_usuario]").val();


		if (password == $(this).val()) {
			fncSweetAlertToast("success", "¡Las contraseñas coinciden!", "2000")
		} else {
			fncSweetAlertToast("warning", "¡Las contraseñas NO coinciden!", "2000")
			$(this).val("")
		}

	})



	var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
	var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
		return new bootstrap.Tooltip(tooltipTriggerEl)

	})

	$(".copyLink").click(function () {

		navigator.clipboard.writeText($(this).attr("cod"))
			.then(() => {
				fncSweetAlertToast("success", "¡Link copiado correctamente!", "3000")

			})
			.catch(err => {
				fncSweetAlertToast("error", "¡No pudimos copiar el Link!", "3000")

			});
	})


	$('.view-password').on('click', function () {
		let input = $('#passwordChange');
		let icon = $(this);

		if (input.attr('type') === 'password') {
			input.attr('type', 'text');
			icon.removeClass('fa-eye-slash').addClass('fa-eye');
		} else {
			input.attr('type', 'password');
			icon.removeClass('fa-eye').addClass('fa-eye-slash');
		}
	});

	$('#changeFoto').click(function () {
		// Crear el input de archivo (si no está ya en el DOM)
		var inputFile = $('<input>', {
			type: 'file',
			name: 'foto',
			id: 'inputFoto',
			accept: 'image/*',
			style: 'display:none;',
		});

		// Insertar el input en el DOM
		$('body').append(inputFile);

		// Disparar el evento de selección de archivo
		$('#inputFoto').click();

		// Detectar cuando se selecciona un archivo
		$('#inputFoto').change(function () {
			var fileData = this.files[0]; // Obtener el archivo seleccionado
			var formData = new FormData();
			formData.append('foto', fileData); // Agregar el archivo al FormData

			var i = $('#changeFoto').attr('i'); // Obtener el ID del usuario desde el atributo 'i'

			// Agregar el ID de usuario al formulario
			formData.append('i', i);

			// Realizar la solicitud AJAX para subir la foto
			$.ajax({
				url: 'ajax/s_f.php', // URL del archivo PHP que manejará la subida
				type: 'POST',
				data: formData,
				contentType: false,
				processData: false,
				dataType: 'json',
				success: function (response) {
					console.log("response ", response);
					// Si la subida fue exitosa, actualizar la imagen
					if (response.status == 'success') {
						$('#fotoPerfil').attr('src', response.newSrc);
						$('#deleteFoto').attr('img', response.newSrc);
						$('#deleteFoto').removeClass('d-none');
						$('#changeFoto').addClass('d-none');
						$(".fotoPerfil").children("img").attr("src", response.newSrc);

						fncSweetAlertToast("success", "¡Foto de perfil actualizada con éxito!", "3000")

					} else {
						fncSweetAlertToast("error", "Hubo un error al subir la foto", "3000")

					}
				},
				error: function () {
					fncSweetAlertToast("error", "Hubo un problema con la subida de la foto", "3000")

				}
			});

			// Eliminar el input de archivo del DOM después de que se haya usado
			$('#inputFoto').remove();
		});
	});

	$('#deleteFoto').click(function () {
		
			var data = new FormData();
			data.append('foto', $(this).attr("img")); 
			data.append('i', $(this).attr("i"));
			data.append('deleteFoto', "true");


			$.ajax({
				url: 'ajax/s_f.php', // URL del archivo PHP que manejará la subida
				type: 'POST',
				data: data,
				contentType: false,
				processData: false,
				dataType: 'json',
				success: function (response) {
					console.log("response ", response);
					// Si la subida fue exitosa, actualizar la imagen
					if (response.status == 'success') {

						$('#deleteFoto').addClass('d-none');
						$('#changeFoto').removeClass('d-none');
						$('#fotoPerfil').attr('src', "public/img/default.jpg");
						$(".fotoPerfil").children("img").attr("src", "public/img/default.jpg");

						fncSweetAlertToast("success", "¡Foto de perfil eliminada con éxito!", "3000")

					} else {
						fncSweetAlertToast("error", "Hubo un error al eliminar la foto", "3000")

					}
				},
				error: function () {
					fncSweetAlertToast("error", "Hubo un problema con eliminar la imagen, recargar la pagina", "3000")

				}
			});

			
	});
});

